import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=84ae7ae0&scoped=true&"
import script from "./Cards.vue?vue&type=script&lang=js&"
export * from "./Cards.vue?vue&type=script&lang=js&"
import style0 from "./Cards.vue?vue&type=style&index=0&id=84ae7ae0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ae7ae0",
  null
  
)

export default component.exports